import { render, staticRenderFns } from "./DirectPayment.vue?vue&type=template&id=e464b60e&"
import script from "./DirectPayment.js?vue&type=script&lang=js&"
export * from "./DirectPayment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports